export default __webpack_public_path__ + "static/media/information--camp--g2.b85f120d.png";